// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
/* eslint-disable
    react/prefer-stateless-function
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.

import React from 'react';

import * as analytics from 'analytics/Analytics';
import {CRISPRAssemblyPrimer} from 'constants/CRISPRConstants';
import notifications from 'notifications';
import Col from 'ui-library/bs/Col';
import Row from 'ui-library/bs/Row';
import Clipboard from 'ui-library/Clipboard';

import CRISPRAssemblyActions from './CRISPRAssemblyActions';

const IDT_ORDER_FORM = 'http://www.idtdna.com/order/OrderEntry.aspx';

interface Props {
  assemblyCid: string;
  assemblyPrimers?: Array<CRISPRAssemblyPrimer>;
  sequenceName: string;
}

class CompletedAssemblyStep extends React.Component<Props> {
  render(): JSX.Element {
    return (
      <Row>
        <Col sm={12}>
          <h3 className="u-spacing-bottom">Your assembly is complete!</h3>
          <div className="well">
            <p>Open the primers and plasmids from the file browser at the left. You can also</p>
            <ul>
              <li className="u-small-spacing-bottom">
                <a
                  onClick={() => {
                    CRISPRAssemblyActions.createEntry(this.props.assemblyCid, this.props.sequenceName);
                    analytics.track('crispr', 'created_assembly_entry');
                  }}
                >
                  create a notebook entry
                </a>
                {' with the '}
                <b>cloning protocol</b>
                {' and the sequences linked.'}
              </li>
              <li>
                <a>
                  <Clipboard
                    value={this.props
                      .assemblyPrimers!.map((primer) => [primer.name, primer.bases].join('\t'))
                      .join('\n')}
                    notifyCopied={function () {
                      notifications.success('Primers have been copied in tab-delimited format.', {
                        duration: 6,
                        id: 'assembly-primers-copied',
                      });
                      analytics.track('crispr', 'copied_assembly_primers');
                    }}
                  >
                    copy the primer list
                  </Clipboard>
                </a>
                {' to your clipboard. (Paste it into Excel or '}
                <a href={IDT_ORDER_FORM} target="_blank" rel="noopener noreferrer">
                  IDT's order form
                </a>
                .)
              </li>
            </ul>
          </div>
        </Col>
      </Row>
    );
  }
}

export default CompletedAssemblyStep;
